import React from "react";
import Title from "../../atoms/title/title";
import { FaCalendarAlt } from "@react-icons/all-files/fa/FaCalendarAlt";
import { FaClock } from "@react-icons/all-files/fa/FaClock";
import "./recentEditions.scss";
import { Link } from "gatsby";

export interface IRecentEditions {
  titulo?: string;
  className?: string;
  editions: {
    tags: string[];
    title: string;
    description: string;
    imageURL: string;
    slug: string;
    label?: string;
    labelB?: string;
  }[];
}

const RecentEditions = (props: IRecentEditions) => {
  const { titulo, editions } = props;
  const compClass = "m-editions";
  
  return (
    <div
      className={`${compClass} ${
        props.className ? props.className : ""
      }`.trim()}
    >
      {titulo && <Title titulo={titulo} />}
      <div className={`${compClass}__container`}>
        {editions.map((edition, key) => (
          <div className={`${compClass}__card`} key={key}>
            <Link to={edition.slug} className="editions__card-link">
              <div
                className={`${compClass}__card-img`}
                style={{ backgroundImage: `url(${edition.imageURL})` }}
              ></div>
            </Link>
            <Link to={editions[0].tags[0][0] === "Editoriales" ? "/editoriales" : "/" + edition.slug.split("/", 2).join("")} className={`${compClass}__card-category`}>
                <p>{edition.tags?.join(", ")}</p>
            </Link>
            <Link to={edition.slug}>
              <div className={`${compClass}__card-title`}>
                <p
                  dangerouslySetInnerHTML={{
                    __html: edition.title,
                  }}
                ></p>
              </div>
            </Link>
            <div className={`${compClass}__card-content`}>
              {edition.label && (
                <span className={`${compClass}__card-date`}>
                  <FaCalendarAlt /> {edition.label}
                </span>
              )}
              {edition.labelB && (
                <span className={`${compClass}__card-time`}>
                  <FaClock /> {edition.labelB}
                </span>
              )}
            </div>
            <div className={`${compClass}__card-description`}>
              <p>{edition.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentEditions;
